/*
 * data for select boxes
 */

/*
 * If the label or value for 'Goalkeeping' changes, then you may also need to change
 * find-player.js > setPlayer() > the line:
 * skills[skills.findIndex(i => i.label == 'Goalkeeping')].value = player.position != 'GK' ? 0 : 7;
 * Update the array label name and/or value
 */

window.skills = {
    'en': [
        { value: 1, originalValue: 1, label: 'Overall' },
        { value: 2, originalValue: 2, label: 'Shooting' },
        { value: 3, originalValue: 3, label: 'Creating' },
        { value: 4, originalValue: 4, label: 'Passing' },
        { value: 5, originalValue: 5, label: 'Possession' },
        { value: 6, originalValue: 6, label: 'Defensive Work' },
        { value: 7, originalValue: 7, label: 'Goalkeeping' },
    ],
    'fr': [
        { value: 1, originalValue: 1, label: 'Total' },
        { value: 2, originalValue: 2, label: 'Tir ' },
        { value: 3, originalValue: 3, label: 'Création' },
        { value: 4, originalValue: 4, label: 'Passe' },
        { value: 5, originalValue: 5, label: 'Possession' },
        { value: 6, originalValue: 6, label: 'Défense' },
        { value: 7, originalValue: 7, label: 'Goal' },
    ],
    'it': [
        { value: 1, originalValue: 1, label: 'Totale' },
        { value: 2, originalValue: 2, label: 'Tiro' },
        { value: 3, originalValue: 3, label: 'Impostazione' },
        { value: 4, originalValue: 4, label: 'Passaggio' },
        { value: 5, originalValue: 5, label: 'Possesso' },
        { value: 6, originalValue: 6, label: 'Difesa' },
        { value: 7, originalValue: 7, label: 'Portiere' },
    ],
    'es': [
        { value: 1, originalValue: 1, label: 'Total' },
        { value: 2, originalValue: 2, label: 'Remate' },
        { value: 3, originalValue: 3, label: 'Creación' },
        { value: 4, originalValue: 4, label: 'Pase' },
        { value: 5, originalValue: 5, label: 'Posesión' },
        { value: 6, originalValue: 6, label: 'Defensa' },
        { value: 7, originalValue: 7, label: 'Portero' },
    ],
    'de': [
        { value: 1, originalValue: 1, label: 'Allgemein' },
        { value: 2, originalValue: 2, label: 'Schüsse' },
        { value: 3, originalValue: 3, label: 'Spielgestaltung' },
        { value: 4, originalValue: 4, label: 'Passspiel' },
        { value: 5, originalValue: 5, label: 'Ballbesitz' },
        { value: 6, originalValue: 6, label: 'Verteidigung' },
        { value: 7, originalValue: 7, label: 'Torwart' },
    ],
    'pt': [
        { value: 1, originalValue: 1, label: 'Total' },
        { value: 2, originalValue: 2, label: 'Chute' },
        { value: 3, originalValue: 3, label: 'Criação' },
        { value: 4, originalValue: 4, label: 'Passagem' },
        { value: 5, originalValue: 5, label: 'Posse de bola' },
        { value: 6, originalValue: 6, label: 'Defesa' },
        { value: 7, originalValue: 7, label: 'Guarda redes' },
    ],
};
window.skillsOriginal = JSON.parse(JSON.stringify(skills));

window.positions = [
    { value: 'GK', positions: ['GK'] },
    { value: 'FB', positions: ['LB', 'LWB', 'RB', 'RWB'] },
    { value: 'CB', positions: ['CB', 'LCB', 'RCB', 'DEF'] },
    { value: 'M', positions: ['DM', 'CM', 'LM', 'RM', 'MID'] },
    { value: 'AM', positions: ['AM', 'LW', 'RW'] },
    { value: 'ST', positions: ['ST', 'FW'] },
];

window.positionsTranslated = {
    'en': [
        { value: 'GK', label: 'Goalkeepers (GK)' },
        { value: 'FB', label: 'Full backs (FB)' },
        { value: 'CB', label: 'Centre backs (CB)' },
        { value: 'M', label: 'Midfielders (M)' },
        { value: 'AM', label: 'Attacking midfielders (AM)' },
        { value: 'ST', label: 'Strikers (S)' },
    ],
    'fr': [
        { value: 'GK', label: 'Goal (G)' },
        { value: 'FB', label: 'Lateral' },
        { value: 'CB', label: 'Defense centrale (DC)' },
        { value: 'M', label: 'Centre millieu (CM)' },
        { value: 'AM', label: 'Milieu de terrain offensive' },
        { value: 'ST', label: 'Buteur' },
    ],
    'it': [
        { value: 'GK', label: 'Portiere (P)' },
        { value: 'FB', label: 'Difensore esterno (DE)' },
        { value: 'CB', label: 'Difensore Centrale (DC)' },
        { value: 'M', label: 'Centrocamapista (C)' },
        { value: 'AM', label: 'Centrocampista offensivo (CO)' },
        { value: 'ST', label: 'Attaccante (AT)' },
    ],
    'es': [
        { value: 'GK', label: 'Portero (POR)' },
        { value: 'FB', label: 'Lateral (L)' },
        { value: 'CB', label: 'Defensa central (DFC)' },
        { value: 'M', label: 'Medio centro (MC)' },
        { value: 'AM', label: 'Medio centro ofensivo (MCO)' },
        { value: 'ST', label: 'Delantero (D)' },
    ],
    'de': [
        { value: 'GK', label: 'Torwart (TW)' },
        { value: 'FB', label: 'Außenverteidiger (AV)' },
        { value: 'CB', label: 'Innenverteidiger (IV)' },
        { value: 'M', label: 'Zentrales Mittelfeld (ZM)' },
        { value: 'AM', label: 'Spielmacher (ZOM)' },
        { value: 'ST', label: 'Stürmer (ST)' },
    ],
    'pt': [
        { value: 'GK', label: 'Guarda redes (GR)' },
        { value: 'FB', label: 'Lateral (L)' },
        { value: 'CB', label: 'Defesa central (DC)' },
        { value: 'M', label: 'Médio centro (MC)' },
        { value: 'AM', label: 'Médio ofensivo (MO)' },
        { value: 'ST', label: 'Ponta de lança (PL)' },
    ],
};


window.rankingsPositionsTranslated = {
    'en': [
        { value: 'GK', label: 'Goalkeepers (GK)' },
        { value: 'FB', label: 'Full backs (FB)' },
        { value: 'CB', label: 'Centre backs (CB)' },
        { value: 'DM', label: 'Defensive Midfielders (DM)' },
        { value: 'CM', label: 'Center Midfielders (CM)' },
        { value: 'AM', label: 'Attacking midfielders (AM)' },
        { value: 'W',  label: 'Wingers (W)' },
        { value: 'ST', label: 'Strikers (S)' },
    ],
    'fr': [
        { value: 'GK', label: 'Goal (G)' },
        { value: 'FB', label: 'Lateral (L)' },
        { value: 'CB', label: 'Defense centrale (DC)' },
        { value: 'DM', label: 'Milieu défensif (DM)' },
        { value: 'CM', label: 'Milieu de terrain central (CM)' },
        { value: 'AM', label: 'Milieu de terrain offensive (OM)' },
        { value: 'W',  label: 'Ailiers (A)' },
        { value: 'ST', label: 'Buteur (B)' },
    ],
    'it': [
        { value: 'GK', label: 'Portiere (P)' },
        { value: 'FB', label: 'Difensore esterno (DE)' },
        { value: 'CB', label: 'Difensore Centrale (DC)' },
        { value: 'DM', label: 'Centrocampisti Difensivi (DM)' },
        { value: 'CM', label: 'Centrocampisti Centrali (CC)' },
        { value: 'AM', label: 'Centrocampista offensivo (CO)' },
        { value: 'W',  label: 'Ali (A)' },
        { value: 'ST', label: 'Attaccante (AT)' },
    ],
    'es': [
        { value: 'GK', label: 'Portero (POR)' },
        { value: 'FB', label: 'Lateral (L)' },
        { value: 'CB', label: 'Defensa central (DFC)' },
        { value: 'DM', label: 'Mediocampistas defensivos (DM)' },
        { value: 'CM', label: 'Mediocampistas centrales (MC)' },
        { value: 'AM', label: 'Medio centro ofensivo (MCO)' },
        { value: 'W',  label: 'Alas (A)' },
        { value: 'ST', label: 'Delantero (D)' },
    ],
    'de': [
        { value: 'GK', label: 'Torwart (TW)' },
        { value: 'FB', label: 'Außenverteidiger (AV)' },
        { value: 'CB', label: 'Innenverteidiger (IV)' },
        { value: 'DM', label: 'Defensive Mittelfeldspieler (DM)' },
        { value: 'CM', label: 'Zentrale Mittelfeldspieler (ZM)' },
        { value: 'AM', label: 'Spielmacher (ZOM)' },
        { value: 'W',  label: 'Flügelspieler (F)' },
        { value: 'ST', label: 'Stürmer (ST)' },
    ],
    'pt': [
        { value: 'GK', label: 'Guarda redes (GR)' },
        { value: 'FB', label: 'Lateral (L)' },
        { value: 'CB', label: 'Defesa central (DC)' },
        { value: 'DM', label: 'Médio defensivo (MD)' },
        { value: 'CM', label: 'Médio centro (MC)' },
        { value: 'AM', label: 'Médio ofensivo (MO)' },
        { value: 'W',  label: 'Extremos (E)' },
        { value: 'ST', label: 'Ponta de lança (PL)' },
    ],
};

window.styles = {
    'en': [
        { value: 1, label: 'Generic' },
        { value: 2, label: 'Tiki-taka' },
        { value: 3, label: 'Gegenpressing' },
        { value: 4, label: 'Width' },
        { value: 5, label: 'Counter Attack' },
        { value: 6, label: 'Cautious' },
    ],
    'fr': [
        { value: 1, label: 'Generic' },
        { value: 2, label: 'Tiki-taka' },
        { value: 3, label: 'Gegenpressing' },
        { value: 4, label: 'Width' },
        { value: 5, label: 'Counter Attack' },
        { value: 6, label: 'Cautious' },
    ],
    'it': [
        { value: 1, label: 'Generico' },
        { value: 2, label: 'Tiki Taka' },
        { value: 3, label: 'Gegenpress' },
        { value: 4, label: 'Uso degli esterni' },
        { value: 5, label: 'Contropiede' },
        { value: 6, label: 'Prudente' },
    ],
    'es': [
        { value: 1, label: 'Genérico' },
        { value: 2, label: 'Tiki-taka' },
        { value: 3, label: 'Gegenpressing' },
        { value: 4, label: 'Juego en amplitud' },
        { value: 5, label: 'Contragolpe' },
        { value: 6, label: 'Prudente' },
    ],
    'de': [
        { value: 1, label: 'Generisch' },
        { value: 2, label: 'Tiki-Taka' },
        { value: 3, label: 'Gegenpressing' },
        { value: 4, label: 'Flügelspiel' },
        { value: 5, label: 'Konterspiel' },
        { value: 6, label: 'Horizontal' },
    ],
    'pt': [
        { value: 1, label: 'Genérico' },
        { value: 2, label: 'Tiki-taka' },
        { value: 3, label: 'Contrapressão' },
        { value: 4, label: 'Amplitude' },
        { value: 5, label: 'Contra ataque' },
        { value: 6, label: 'Prudência' },
    ],
};

window.stats = {
    shooting: {
        'en': [
            { value: 1, label: 'Goals' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Shots' },
            { value: 4, label: 'Shots on target' },
            { value: 5, label: 'Shots on target %' },
            // { value: 6, label: 'Headers' },
            // { value: 7, label: 'Headers on target %' },
            // { value: 8, label: 'Goal conversion %' },
        ],
        'fr': [
            { value: 1, label: 'But' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Tirs' },
            { value: 4, label: 'Tirs cadrés' },
            { value: 5, label: 'Tirs cadrés %' },
            // { value: 6, label: 'Tête' },
            // { value: 7, label: 'Tête cadré' },
            // { value: 8, label: 'Conversion de buts %' },
        ],
        'it': [
            { value: 1, label: 'Gol' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Tiri' },
            { value: 4, label: 'Tiri nello specchio' },
            { value: 5, label: 'Tiri nello specchio %' },
            // { value: 6, label: 'Colpi di testa' },
            // { value: 7, label: 'Colpi di testa nello specchio %' },
            // { value: 8, label: 'Trasformazione in goal %' },
        ],
        'es': [
            { value: 1, label: 'Goles' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Remates' },
            { value: 4, label: 'Remates a portería' },
            { value: 5, label: 'Remates a portería %' },
            // { value: 6, label: 'Remates de cabeza' },
            // { value: 7, label: 'Remates de cabeza a portería %' },
            // { value: 8, label: 'Conversión en gol %' },
        ],
        'de': [
            { value: 1, label: 'Tore' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Schüsse' },
            { value: 4, label: 'Schüsse aufs Tor' },
            { value: 5, label: 'Schüsse aufs Tor %' },
            // { value: 6, label: 'Kopfbälle' },
            // { value: 7, label: 'Kopfbälle aufs Tor %' },
            // { value: 8, label: 'Tor Trefferquote %' },
        ],
        'pt': [
            { value: 1, label: 'Golo' },
            // { value: 2, label: 'xG' },
            { value: 3, label: 'Remate' },
            { value: 4, label: 'Finalizações' },
            { value: 5, label: 'Finalizações %' },
            // { value: 6, label: 'Cabeceamentos' },
            // { value: 7, label: 'Finalizações de cabeça no golo %' },
            // { value: 8, label: 'Conversão de golos %' },
        ]
    },
    creating: {
        'en': [
            { value: 9, label: 'Assists' },
            { value: 10, label: 'Key passes' },
            { value: 11, label: 'Shot assists' },
            // { value: 12, label: 'Attacking actions' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Through passes' },
            // { value: 15, label: 'Successful through passes %' },
            { value: 16, label: 'Crosses' },
        ],
        'fr': [
            { value: 9, label: 'Assists' },
            { value: 10, label: 'Passes décisives' },
            { value: 11, label: 'Tir assiste' },
            // { value: 12, label: 'Actions offensive' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Passes décisives ' },
            // { value: 15, label: 'Passes décisives %' },
            { value: 16, label: 'Centres' },
        ],
        'it': [
            { value: 9, label: 'Assists' },
            { value: 10, label: 'Passaggi chiave' },
            { value: 11, label: 'Passaggio per il tiro' },
            // { value: 12, label: 'Azioni offensive' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Passaggi filtranti' },
            // { value: 15, label: 'Successo passaggi filtranti %' },
            { value: 16, label: 'Cross' },
        ],
        'es': [
            { value: 9, label: 'Asistencias' },
            { value: 10, label: 'Pases clave' },
            { value: 11, label: 'Asistencias para remates' },
            // { value: 12, label: 'Acciones ofensivas' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Pases al hueco' },
            // { value: 15, label: 'Pases al hueco completados %' },
            { value: 16, label: 'Centros' },
        ],
        'de': [
            { value: 9, label: 'Torvorlagen (Assists)' },
            { value: 10, label: 'Schlüsselpässe' },
            { value: 11, label: 'Torschussvorlagen' },
            // { value: 12, label: 'Angriffsaktionen' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Efrolgreiche Steilpässe ' },
            // { value: 15, label: 'Efrolgreiche Steilpässe %' },
            { value: 16, label: 'Flanken' },
        ],
        'pt': [
            { value: 9, label: 'Assistência' },
            { value: 10, label: 'Passes chave' },
            { value: 11, label: 'Passes decisivos' },
            // { value: 12, label: 'Ação ofensiva' },
            // { value: 13, label: 'xA' },
            // { value: 14, label: 'Passes em profundidade passes' },
            // { value: 15, label: 'Passes em profundidade %' },
            { value: 16, label: 'Cruzamento' },
        ]
    },
    passing: {
        'en': [
            { value: 17, label: 'Passes' },
            { value: 18, label: 'Successful passes %' },
            // { value: 19, label: 'Smart passes' },
            // { value: 20, label: 'Successful smart passes %' },
            // { value: 21, label: 'Passes to final third' },
            // { value: 22, label: 'Linkup plays' },
            { value: 23, label: 'Progressive passes' },
            { value: 24, label: 'Successful progressive passes %' },
        ],
        'fr': [
            { value: 17, label: 'Passes' },
            { value: 18, label: 'Passes complete %' },
            // { value: 19, label: 'Passes intelligentes' },
            // { value: 20, label: 'Passes intelligentes achevée %' },
            // { value: 21, label: 'Passe au dernier tiers' },
            // { value: 22, label: 'Jeux de liaison' },
            { value: 23, label: 'Passes progressive' },
            { value: 24, label: 'Passes progressive achevée %' },
        ],
        'it': [
            { value: 17, label: 'Passaggi' },
            { value: 18, label: 'Passaggi completati %' },
            // { value: 19, label: 'Passaggi intelligenti' },
            // { value: 20, label: 'Passaggi intelligenti completati %' },
            // { value: 21, label: 'Passaggi nella trequarti avversaria' },
            // { value: 22, label: 'Giocate in combinazione' },
            { value: 23, label: 'Passaggi in avanti' },
            { value: 24, label: 'Passaggi in avanti completati' },
        ],
        'es': [
            { value: 17, label: 'Pases' },
            { value: 18, label: 'Pases completados %' },
            // { value: 19, label: 'Pases inteligentes' },
            // { value: 20, label: 'Pases inteligentes completados %' },
            // { value: 21, label: 'Pases en los tres cuartos' },
            // { value: 22, label: 'Jugadas combinadas' },
            { value: 23, label: 'Pases progresivos' },
            { value: 24, label: 'Pases progresivos completados %' },
        ],
        'de': [
            { value: 17, label: 'Pässe' },
            { value: 18, label: 'Erfolgreiche Pässe %' },
            // { value: 19, label: 'Intelligente pässe' },
            // { value: 20, label: 'Erfolgreiche intelligente pässe %' },
            // { value: 21, label: 'Pässe ins letzte Drittel' },
            // { value: 22, label: 'Kombinationsspiele' },
            { value: 23, label: 'Progressive Pässe' },
            { value: 24, label: 'Efrolgreiche progressive pässe %' },
        ],
        'pt': [
            { value: 17, label: 'Passes' },
            { value: 18, label: 'Passes bem sucedidos %' },
            // { value: 19, label: 'Passes inteligentes' },
            // { value: 20, label: 'Passes inteligentes bem sucedidos %' },
            // { value: 21, label: 'Passes no ultimo terço' },
            // { value: 22, label: 'Jogadas ensaiadas' },
            { value: 23, label: 'Passes progressivos' },
            { value: 24, label: 'Passes progressivos bem sucedidos %' },
        ]
    },
    defensiveWork: {
        'en': [
            { value: 25, label: 'Ball recoveries' },
            { value: 26, label: 'Defensive duels' },
            { value: 27, label: 'Defensive duels won' },
            { value: 28, label: 'Duels won %' },
            { value: 29, label: 'Aerial duels' },
            { value: 30, label: 'Interceptions' },
            // { value: 31, label: 'Defensive actions' },
            { value: 32, label: 'Dribbles against won' },
        ],
        'fr': [
            { value: 25, label: 'Récupération du ballon' },
            { value: 26, label: 'Duel défensive' },
            { value: 27, label: 'Duel défensive gagner' },
            { value: 28, label: 'Dribble gagner %' },
            { value: 29, label: 'Duel dans les airs' },
            { value: 30, label: 'Interception' },
            // { value: 31, label: 'Actions défensive' },
            { value: 32, label: 'Dribble gagner' },

        ],
        'it': [
            { value: 25, label: 'Palle recuperate' },
            { value: 26, label: 'Duelli difensivi' },
            { value: 27, label: 'Duelli difensivi vinti' },
            { value: 28, label: 'Duelli vinti %' },
            { value: 29, label: 'Duelli aerei' },
            { value: 30, label: 'Palle intercettate' },
            // { value: 31, label: 'Azioni difensive' },
            { value: 32, label: 'Dribbling contro vinti' },
        ],
        'es': [
            { value: 25, label: 'Recuperaciones' },
            { value: 26, label: 'Duelos defensivos' },
            { value: 27, label: 'Duelos defensivos ganados' },
            { value: 28, label: 'Duelos ganados %' },
            { value: 29, label: 'Duelos aéreos' },
            { value: 30, label: 'Pelotas interceptadas' },
            // { value: 31, label: 'Acciones defensivas' },
            { value: 32, label: 'Regates frustrados' },
        ],
        'de': [
            { value: 25, label: 'Bälle erobert' },
            { value: 26, label: 'Zweikämpfe' },
            { value: 27, label: 'Defensive Zweikämpfe gewonnen' },
            { value: 28, label: 'Zweikämpfe gewonnen %' },
            { value: 29, label: 'Luftzweikämpfe' },
            { value: 30, label: 'Ball abgefangen' },
            // { value: 31, label: 'Defensivaktionen' },
            { value: 32, label: 'Erfolgreiche Dribblings' },
        ],
        'pt': [
            { value: 25, label: 'Bolas recuperadas' },
            { value: 26, label: 'Duelo defensivo' },
            { value: 27, label: 'Desarmes bem sucedidos' },
            { value: 28, label: 'Duelos bem sucedidos %' },
            { value: 29, label: 'Duelos aéreos' },
            { value: 30, label: 'Intercepções' },
            // { value: 31, label: 'Desarmes' },
            { value: 32, label: 'Dribles bem sucedidos' },
        ]
    },
    possession: {
        'en': [
            { value: 33, label: 'Offensive duels' },
            { value: 34, label: 'Dribbles' },
            { value: 35, label: 'Successful dribbles' },
            { value: 36, label: 'Successful dribbles %' },
            { value: 37, label: 'Received pass' },
            // { value: 38, label: 'Touch in box' },
            // { value: 39, label: 'Progressive run' },
            // { value: 40, label: 'Fouls suffered' },
        ],
        'fr': [
            { value: 33, label: 'Duel offensive' },
            { value: 34, label: 'Dribble' },
            { value: 35, label: 'Dribbles réussis' },
            { value: 36, label: 'Dribbles réussis %' },
            { value: 37, label: 'Pass reçu' },
            // { value: 38, label: 'Toucher dans la boîte' },
            // { value: 39, label: 'Course progressive' },
            // { value: 40, label: 'Fautes subies' },
        ],
        'it': [
            { value: 33, label: 'Duelli offensivi' },
            { value: 34, label: 'Dribbling' },
            { value: 35, label: 'Dribbling completati' },
            { value: 36, label: 'Dribbling completati %' },
            { value: 37, label: 'Passaggi ricevuti' },
            // { value: 38, label: 'Tocchi in area' },
            // { value: 39, label: 'Allunghi' },
            // { value: 40, label: 'Falli subiti' },
        ],
        'es': [
            { value: 33, label: 'Duelos ofensivos' },
            { value: 34, label: 'Regates' },
            { value: 35, label: 'Regates completados' },
            { value: 36, label: 'Regates completados %' },
            { value: 37, label: 'Pases recibidos' },
            // { value: 38, label: 'Toques en el area contraria' },
            // { value: 39, label: 'Carrera progresiva' },
            // { value: 40, label: 'Faltas recibidas' },
        ],
        'de': [
            { value: 33, label: 'Offensive Zweikämpfe' },
            { value: 34, label: 'Dribblings' },
            { value: 35, label: 'Erfolgreiche Dribblings' },
            { value: 36, label: 'Erfolgreiche Dribblings %' },
            { value: 37, label: 'Erhaltene Pässe' },
            // { value: 38, label: 'Ballkontakte im Strafraum' },
            // { value: 39, label: 'Progressiver Lauf' },
            // { value: 40, label: 'Gefoult worden' },
        ],
        'pt': [
            { value: 33, label: 'Duelo ofensivo' },
            { value: 34, label: 'Dribles' },
            { value: 35, label: 'Sequencia de dribles' },
            { value: 36, label: 'Sequencia de dribles %' },
            { value: 37, label: 'Recepções' },
            // { value: 38, label: 'Toques na área' },
            // { value: 39, label: 'Corrida progressiva' },
            // { value: 40, label: 'Faltas sofridas' },
        ]
    },
    goalkeeping: {
        'en': [
            // { value: 41, label: 'xG saved' },
            // { value: 42, label: 'Goals conceded' },
            { value: 43, label: 'Shots against' },
            // { value: 44, label: 'Aerial duels' },
            // { value: 45, label: 'Aerial duels won' },
            // { value: 46, label: 'Aerial duels won %' },
            { value: 47, label: 'Saves' },
            { value: 48, label: 'Saves %' },
            // { value: 49, label: 'Exits' },
            { value: 50, label: 'Ball recoveries' },
            { value: 51, label: 'Successful Passes %' },
            { value: 52, label: 'Goal kicks' },
            { value: 53, label: 'Successful goal kicks' },
            { value: 54, label: 'Successful goal kick %' },
            // { value: 55, label: 'Short goal kicks' },
            // { value: 56, label: 'Long goal kicks' },
        ],
        'fr': [
            // { value: 41, label: 'XG défendue' },
            // { value: 42, label: 'Buts encaissés' },
            { value: 43, label: 'But contré' },
            // { value: 44, label: 'Duel aérien' },
            // { value: 45, label: 'Duel aérien gagnée' },
            // { value: 46, label: 'Duel aérien gagnée %' },
            { value: 47, label: 'Sauve' },
            { value: 48, label: 'Sauve %' },
            // { value: 49, label: 'Sortie' },
            { value: 50, label: 'Récupération du ballon' },
            { value: 51, label: 'Dribbles réussis %' },
            { value: 52, label: 'Tirs au but' },
            { value: 53, label: 'Tirs réussies' },
            { value: 54, label: 'Tirs réussies %' },
            // { value: 55, label: 'Coups de pied courts' },
            // { value: 56, label: 'Coups de pied longs' },
        ],
        'it': [
            // { value: 41, label: 'Xg parati' },
            // { value: 42, label: 'Gol concessi' },
            { value: 43, label: 'Tiri contro' },
            // { value: 44, label: 'Duelli aerei' },
            // { value: 45, label: 'Duelli aerei vinti' },
            // { value: 46, label: 'Duelli aerei vinti %' },
            { value: 47, label: 'Parate' },
            { value: 48, label: 'Parate %' },
            // { value: 49, label: 'Uscite' },
            { value: 50, label: 'Palle recuperate' },
            { value: 51, label: 'Passaggi completati %' },
            { value: 52, label: 'Tiri in porta' },
            { value: 53, label: 'Tiri in porta completati' },
            { value: 54, label: 'Tiri in porta completati %' },
            // { value: 55, label: 'Tiri in porta da vicino' },
            // { value: 56, label: 'Tiri in porta da lontano' },
        ],
        'es': [
            // { value: 41, label: 'Xg atajados' },
            // { value: 42, label: 'Goles encajados' },
            { value: 43, label: 'Remates recibidos' },
            // { value: 44, label: 'Duelos aereos' },
            // { value: 45, label: 'Duelos aereos ganados' },
            // { value: 46, label: 'Duelos aereos ganados %' },
            { value: 47, label: 'Paradas' },
            { value: 48, label: 'Paradas %' },
            // { value: 49, label: 'Salidas' },
            { value: 50, label: 'Recuperaciones' },
            { value: 51, label: 'Pases completados %' },
            { value: 52, label: 'Saques de meta' },
            { value: 53, label: 'Tiros a portería completados' },
            { value: 54, label: 'Saques de meta %' },
            // { value: 55, label: 'Remates de corta distancia' },
            // { value: 56, label: 'Remates de larga distancia' },
        ],
        'de': [
            // { value: 41, label: 'xG erwartete Paraden' },
            // { value: 42, label: 'Gegentore' },
            { value: 43, label: 'Schüsse auf' },
            // { value: 44, label: 'Luftzweikämpfe' },
            // { value: 45, label: 'Luftzweikämpfe gewonnen' },
            // { value: 46, label: 'Luftzweikämpfe gewonnen %' },
            { value: 47, label: 'Paraden' },
            { value: 48, label: 'Paraden %' },
            // { value: 49, label: 'Exits' },
            { value: 50, label: 'Bälle erobert' },
            { value: 51, label: 'Bälle erobert %' },
            { value: 52, label: 'Torschüsse' },
            { value: 53, label: 'Torschüsse abgeschlossen' },
            { value: 54, label: 'Torschüsse abgeschlossen %' },
            // { value: 55, label: 'Kurze Abschläge' },
            // { value: 56, label: 'Lange Abschläge' },
        ],
        'pt': [
            // { value: 41, label: 'XG defendidos' },
            // { value: 42, label: 'Golos sofridos' },
            { value: 43, label: 'Remates Contra' },
            // { value: 44, label: 'Duelos aéreos' },
            // { value: 45, label: 'Duelos aéreos bem sucedidos' },
            // { value: 46, label: 'Duelos aéreos bem sucedidos %' },
            { value: 47, label: 'Defesas' },
            { value: 48, label: 'Defesas %' },
            // { value: 49, label: 'Saídas' },
            { value: 50, label: 'Bolas recuperadas' },
            { value: 51, label: 'Passes bem sucedidos %' },
            { value: 52, label: 'Chutes de meta' },
            { value: 53, label: 'Finalizações bem sucedidas' },
            { value: 54, label: 'Finalizações bem sucedidas %' },
            // { value: 55, label: 'Finalizações à curta distância' },
            // { value: 56, label: 'Finalizações à longa distância' },
        ]
    },
    proAdditional: {
        'en': [
            { value: 57, label: 'Successful key passes' },
            { value: 58, label: 'Loose ball duels won' },
            { value: 59, label: 'Accelerations' },
            { value: 60, label: 'Successful long passes' },
            { value: 61, label: 'Successful smart passes' },
            { value: 62, label: 'Successful crosses' },
            { value: 63, label: 'Second assists' },
            { value: 64, label: 'Opponent half recoveries' },
            { value: 65, label: 'Pressing duels' },
            { value: 66, label: 'Successful through passes' },
            { value: 67, label: 'Aerial duels won' },
            { value: 68, label: 'Offensive duels won' },
            { value: 69, label: 'Own half losses' },
            { value: 70, label: 'Duels won' },
            { value: 71, label: 'Successful passes to final third' },
            { value: 72, label: 'Successful forward passes' },
            { value: 73, label: 'Successful progressive passes' },
        ],
        'fr': [
            { value: 57, label: 'Passage clé achevée' },
            { value: 58, label: 'Duels de balle vacants gagnés' },
            { value: 59, label: 'Accélérations' },
            { value: 60, label: 'Passes longues achevée' },
            { value: 61, label: 'Passes intelligentes achevée' },
            { value: 62, label: 'Croisements achevée' },
            { value: 63, label: 'Deuxième passe décisive' },
            { value: 64, label: 'Demi-récupérations de l\'adversaire' },
            { value: 65, label: 'Duels pressants' },
            { value: 66, label: 'Par des passages achevée' },
            { value: 67, label: 'Duel dans les airs achevée' },
            { value: 68, label: 'Duels offensifs gagnés' },
            { value: 69, label: 'Ballon perdu dans sa moitié de terrain' },
            { value: 70, label: 'Duels gagnés' },
            { value: 71, label: 'Passe au dernier tiers achevée' },
            { value: 72, label: 'Passe en avant achevée' },
            { value: 73, label: 'Passes progressive achevée' },
        ],
        'it': [
            { value: 57, label: 'Passaggi chiave completati' },
            { value: 58, label: 'duelli a palla vagante vinti' },
            { value: 59, label: 'Accelerazioni' },
            { value: 60, label: 'Passaggi lunghi completati' },
            { value: 61, label: 'Passaggi intelligenti completati' },
            { value: 62, label: 'Cross completati' },
            { value: 63, label: 'Secondo assist' },
            { value: 64, label: 'Recuperi nella metà campo avversaria' },
            { value: 65, label: 'Duelli durante pressing' },
            { value: 66, label: 'Passaggi filtranti completati' },
            { value: 67, label: 'Duelli aerei vinti' },
            { value: 68, label: 'Duelli offensivi vinti' },
            { value: 69, label: 'Palle perse nella propria metà campo' },
            { value: 70, label: 'Duelli vinti' },
            { value: 71, label: 'Passaggi nella trequarti avversaria compleatati' },
            { value: 72, label: 'Passaggi in avanti completati' },
            { value: 73, label: 'Passaggi progressivi completati' },
        ],
        'es': [
            { value: 57, label: 'Pases clave completados' },
            { value: 58, label: 'Duelos de balones vacantes ganados' },
            { value: 59, label: 'Aceleraciones' },
            { value: 60, label: 'Pases largos completados' },
            { value: 61, label: 'Pases inteligentes completados' },
            { value: 62, label: 'Cruces compleatados' },
            { value: 63, label: 'Segunda asistencia' },
            { value: 64, label: 'Recuperaciones de la mitad del oponente' },
            { value: 65, label: 'Duelos apremiantes' },
            { value: 66, label: 'Pases al hueco completados' },
            { value: 67, label: 'Duelos aéreos' },
            { value: 68, label: 'Duelos ofensivos ganados' },
            { value: 69, label: 'Pérdidas de balón en su propia mitad' },
            { value: 70, label: 'Duelos ganados' },
            { value: 71, label: 'Pases en los tres cuartos completados' },
            { value: 72, label: 'Pases hacia adelante completados' },
            { value: 73, label: 'Pases progresivos completados' },
        ],
        'de': [
            { value: 57, label: 'Efrolgreiche Schlüsselpässe' },
            { value: 58, label: 'Vakante Ballduelle gewonnen' },
            { value: 59, label: 'Beschleunigungen' },
            { value: 60, label: 'Erfolgreiche lange Pässe' },
            { value: 61, label: 'Erfolgreiche Intelligente pässe' },
            { value: 62, label: 'Erfolgreiche Kreuze' },
            { value: 63, label: 'Zweite Assists' },
            { value: 64, label: 'Gegnerische halbe Erholungen' },
            { value: 65, label: 'Drückende Duelle' },
            { value: 66, label: 'Efrolgreiche Steilpässe' },
            { value: 67, label: 'Luftzweikämpfe gewonnen' },
            { value: 68, label: 'Offensive Duelle gewonnen' },
            { value: 69, label: 'Umsätze in der eigenen Hälfte' },
            { value: 70, label: 'Duelle gewonnen' },
            { value: 71, label: 'Efrolgreiche Pässe ins letzte Drittel' },
            { value: 72, label: 'Efrolgreiche Vorwärtspässe' },
            { value: 73, label: 'Efrolgreiche progressive pässe' },
        ],
        'pt': [
            { value: 57, label: 'Passes chave bem sucedidos' },
            { value: 58, label: 'Segundas bolas ganhas' },
            { value: 59, label: 'Acelerações' },
            { value: 60, label: 'Passes longos bem sucedidos' },
            { value: 61, label: 'Passes inteligentes bem sucedidos' },
            { value: 62, label: 'Cruzamentos bem sucedidos' },
            { value: 63, label: 'Segunda assistência' },
            { value: 64, label: 'Recuperações meio campo ofensivo' },
            { value: 65, label: 'Duelos de pressão' },
            { value: 66, label: 'Passes em profundidade' },
            { value: 67, label: 'Duelos aéreos bem sucedidos' },
            { value: 68, label: 'Duelos ofensivos ganhos' },
            { value: 69, label: 'Perdas de bola meio campo defensivo' },
            { value: 70, label: 'Duelos ganhos' },
            { value: 71, label: 'Passes no ultimo terço bem sucedidos' },
            { value: 72, label: 'Passes para a frente bem sucedidos' },
            { value: 73, label: 'Passes progressivos bem sucedidos' },
        ]
    },
    indexes: {
        'en': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ],
        'fr': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ],
        'it': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ],
        'es': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ],
        'de': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ],
        'pt': [
            { value: 76, label: 'Attacking Index' },
            { value: 77, label: 'Defensive Index' },
        ]
    }
};
